/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import PageDto from './PageDto';

/**
 * The PaginatedPagesDto model module.
 * @module model/PaginatedPagesDto
 * @version v0
 */
class PaginatedPagesDto {
    /**
     * Constructs a new <code>PaginatedPagesDto</code>.
     * @alias module:model/PaginatedPagesDto
     */
    constructor() { 
        
        PaginatedPagesDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>PaginatedPagesDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PaginatedPagesDto} obj Optional instance to populate.
     * @return {module:model/PaginatedPagesDto} The populated <code>PaginatedPagesDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PaginatedPagesDto();

            if (data.hasOwnProperty('page')) {
                obj['page'] = ApiClient.convertToType(data['page'], 'Number');
            }
            if (data.hasOwnProperty('limit')) {
                obj['limit'] = ApiClient.convertToType(data['limit'], 'Number');
            }
            if (data.hasOwnProperty('totalPages')) {
                obj['totalPages'] = ApiClient.convertToType(data['totalPages'], 'Number');
            }
            if (data.hasOwnProperty('totalElements')) {
                obj['totalElements'] = ApiClient.convertToType(data['totalElements'], 'Number');
            }
            if (data.hasOwnProperty('pages')) {
                obj['pages'] = ApiClient.convertToType(data['pages'], [PageDto]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>PaginatedPagesDto</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>PaginatedPagesDto</code>.
     */
    static validateJSON(data) {
        if (data['pages']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['pages'])) {
                throw new Error("Expected the field `pages` to be an array in the JSON data but got " + data['pages']);
            }
            // validate the optional field `pages` (array)
            for (const item of data['pages']) {
                PageDto.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * @member {Number} page
 */
PaginatedPagesDto.prototype['page'] = undefined;

/**
 * @member {Number} limit
 */
PaginatedPagesDto.prototype['limit'] = undefined;

/**
 * @member {Number} totalPages
 */
PaginatedPagesDto.prototype['totalPages'] = undefined;

/**
 * @member {Number} totalElements
 */
PaginatedPagesDto.prototype['totalElements'] = undefined;

/**
 * @member {Array.<module:model/PageDto>} pages
 */
PaginatedPagesDto.prototype['pages'] = undefined;






export default PaginatedPagesDto;

